"use strict";
import { ArrowDownOutlined, DownOutlined, SettingOutlined } from "@ant-design/icons";
import { Input, Modal, Popover, Radio, message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { formatUnits } from "viem";
import { useSendTransaction, useWaitForTransactionReceipt } from "wagmi";
import tokenList from "../tokenList.json";
import MaxButton from "./MaxButton";
import "./index.css";
function OneInchSwap({ address, isConnected }) {
  const [messageApi, contextHolder] = message.useMessage();
  const [slippage, setSlippage] = useState(2.5);
  const [tokenOneAmount, setTokenOneAmount] = useState("");
  const [tokenTwoAmount, setTokenTwoAmount] = useState("");
  const [tokenOne, setTokenOne] = useState(tokenList[0]);
  const [tokenTwo, setTokenTwo] = useState(tokenList[1]);
  const [isOpen, setIsOpen] = useState(false);
  const [changeToken, setChangeToken] = useState(1);
  const [prices, setPrices] = useState(null);
  const [txDetails, setTxDetails] = useState({
    to: null,
    data: null,
    value: null
  });
  const { data: txHash, sendTransaction, isPending: isSending, error: sendError } = useSendTransaction();
  const {
    isLoading: isConfirming,
    isSuccess: isConfirmed,
    error: confirmError
  } = useWaitForTransactionReceipt({
    hash: txHash
  });
  function handleSlippageChange(e) {
    setSlippage(e.target.value);
  }
  function changeAmount(e) {
    const value = e.target.value;
    setTokenOneAmount(value);
    if (value && prices) {
      setTokenTwoAmount((parseFloat(value) * prices.ratio).toFixed(6));
    } else {
      setTokenTwoAmount("");
    }
  }
  function setMaxBal(bal) {
    setTokenOneAmount(bal);
    if (bal && prices) {
      setTokenTwoAmount((parseFloat(bal) * prices.ratio).toFixed(6));
    } else {
      setTokenTwoAmount("");
    }
  }
  function switchTokens() {
    setPrices(null);
    setTokenOneAmount("");
    setTokenTwoAmount("");
    const one = tokenOne;
    const two = tokenTwo;
    setTokenOne(two);
    setTokenTwo(one);
    fetchPrices(two.address, one.address);
  }
  function openModal(asset) {
    setChangeToken(asset);
    setIsOpen(true);
  }
  function modifyToken(i) {
    setPrices(null);
    setTokenOneAmount("");
    setTokenTwoAmount("");
    const selectedToken = tokenList[i];
    if (changeToken === 1) {
      setTokenOne(selectedToken);
      fetchPrices(selectedToken.address, tokenTwo.address);
    } else {
      setTokenTwo(selectedToken);
      fetchPrices(tokenOne.address, selectedToken.address);
    }
    setIsOpen(false);
  }
  async function fetchPrices(one, two) {
    try {
      const res = await axios.get(`https://aggtrade-backend.onrender.com/api/tokenPrice`, {
        params: { addressOne: one, addressTwo: two }
      });
      setPrices(res.data.data);
    } catch (error) {
      console.error("Error fetching prices:", error);
      messageApi.error("Failed to fetch token prices");
    }
  }
  const API = "https://aggtrade-backend.onrender.com/proxy/1inch";
  async function fetchDexSwap() {
    if (!tokenOneAmount || !address || !isConnected) {
      messageApi.warning("Connect wallet and enter an amount");
      return;
    }
    const {
      data: { allowance }
    } = await axios.get(`${API}/approve/allowance?tokenAddress=${tokenOne.address}&walletAddress=${address}`);
    console.log("ALLOWANCE::", allowance);
    const amountWei = BigInt((parseFloat(tokenOneAmount) * 10 ** tokenOne.decimals).toFixed(0));
    console.log("AMOUNT::", amountWei);
    if (BigInt(allowance) < amountWei) {
      const { data: approveTx } = await axios.get(`${API}/approve/transaction?tokenAddress=${tokenOne.address}`);
      setTxDetails({
        to: approveTx.to,
        data: approveTx.data,
        value: BigInt(approveTx.value ?? "0")
      });
      console.log("Token approval required");
      return;
    }
    const swapUrl = `${API}/swap?src=${tokenOne.address}&dst=${tokenTwo.address}&amount=${amountWei}&from=${address}&slippage=${slippage}`;
    const { data: swap } = await axios.get(swapUrl);
    console.log("SWAP::", swap);
    const outHuman = formatUnits(BigInt(swap.toAmount), tokenTwo.decimals);
    setTokenTwoAmount(parseFloat(outHuman).toFixed(6));
    setTxDetails({
      to: swap.tx.to,
      data: swap.tx.data,
      value: BigInt(swap.tx.value ?? "0")
    });
  }
  useEffect(() => {
    if (txDetails.to && txDetails.data && isConnected && sendTransaction) {
      sendTransaction({
        to: txDetails.to,
        data: txDetails.data,
        value: txDetails.value || BigInt(0)
      });
    }
  }, [txDetails, isConnected, sendTransaction]);
  useEffect(() => {
    messageApi.destroy();
    if (isSending || isConfirming) {
      messageApi.open({
        type: "loading",
        content: isSending ? "Sending transaction..." : "Confirming transaction...",
        duration: 0
      });
    }
  }, [isSending, isConfirming, messageApi]);
  useEffect(() => {
    messageApi.destroy();
    if (isConfirmed) {
      messageApi.open({
        type: "success",
        content: "Transaction successful!",
        duration: 3
      });
      setTokenOneAmount("");
      setTokenTwoAmount("");
      setTxDetails({ to: null, data: null, value: null });
    } else if (sendError || confirmError) {
      messageApi.open({
        type: "error",
        content: `Transaction failed: ${sendError?.message || confirmError?.message}`,
        duration: 5
      });
      setTxDetails({ to: null, data: null, value: null });
    }
  }, [isConfirmed, sendError, confirmError, messageApi]);
  useEffect(() => {
    if (tokenList.length >= 2) {
      fetchPrices(tokenList[0].address, tokenList[1].address);
    }
  }, []);
  const settings = <><div>Slippage Tolerance</div><div><Radio.Group value={slippage} onChange={handleSlippageChange}><Radio.Button value={0.5}>0.5%</Radio.Button><Radio.Button value={2.5}>2.5%</Radio.Button><Radio.Button value={5}>5.0%</Radio.Button></Radio.Group></div></>;
  const isSwapDisabled = !tokenOneAmount || !isConnected || !prices || isSending || isConfirming;
  return <>{contextHolder}<Modal open={isOpen} footer={null} onCancel={() => setIsOpen(false)} title="Select a token"><div className="modalContent">{tokenList?.map((token, i) => {
    return <div className="tokenChoice" key={i} onClick={() => modifyToken(i)}><img src={token.img} alt={token.ticker} className="tokenLogo" /><div className="tokenChoiceNames"><div className="tokenName">{token.name}</div><div className="tokenTicker">{token.ticker}</div></div></div>;
  })}</div></Modal><div className="tradeBox"><div className="tradeBoxHeader"><h4 className="heading">Swap</h4><Popover content={settings} title="Settings" trigger="click" placement="bottomRight"><SettingOutlined className="cog" /></Popover></div><div className="inputs"><div className="input-container"><Input placeholder="0" value={tokenOneAmount} onChange={changeAmount} disabled={!prices} /><span className="input-tag">Sell</span></div><div className="switch-container"><div className="line" /><div className="switchButton" onClick={switchTokens}><ArrowDownOutlined className="switchArrow" /></div><div className="line" /></div><div className="input-container"><Input placeholder="0" value={tokenTwoAmount} disabled={true} /><span className="input-tag">Buy</span></div><div className="assetOneContainer"><div className="assetOne" onClick={() => openModal(1)}><img src={tokenOne.img} alt="assetOneLogo" className="assetLogo" />{tokenOne.ticker}<DownOutlined /></div><div className="max-btn-container"><MaxButton token={tokenOne.address} setToken={setMaxBal} /></div></div><div className="assetTowContainer"><div className="assetTwo" onClick={() => openModal(2)}><img src={tokenTwo.img} alt="assetOneLogo" className="assetLogo" />{tokenTwo.ticker}<DownOutlined /></div>{
    /* <div className="max-btn-container">
      <MaxButton token={tokenTwo.address} setToken={setMaxBal} />
    </div> */
  }</div></div><div
    className={`swapButton ${isSwapDisabled ? "disabled" : ""}`}
    onClick={isSwapDisabled ? void 0 : fetchDexSwap}
    style={{
      opacity: isSwapDisabled ? 0.6 : 1,
      cursor: isSwapDisabled ? "not-allowed" : "pointer"
    }}
  >{isConnected ? isSending ? "Sending..." : isConfirming ? "Confirming..." : "Swap" : "Connect Wallet"}</div></div></>;
}
export default OneInchSwap;
